import Auth from '../auth/Auth.js'

export default {
    install (Vue) {
        Vue.prototype.$auth = Auth
    }
}
